import { COLORS } from '@btime/constants'
import { concatIf } from '@btime/helpers'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../components/presentation/Text'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import {
  useOpenBucketsModal,
  useOpenEditBucketModal,
  useOpenEditFieldsModal,
  useOpenExportHistoryModal,
  useOpenExportModal,
  useOpenImportHistoryModal,
  useOpenLinktreesModal
} from '../../../utils/routes/modals/modalsActions'
import DropdownLink from '../../../components/navigation/DropdownLink'
import IconText from '../../../components/presentation/IconText'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const openEditFieldsModal = useOpenEditFieldsModal()
  const { t } = useTranslation(['common', 'listAsset'])

  const canSetup = useSessionPermission('setupAsset')
  const canExport = useSessionPermission('exportAsset')
  const canImport = useSessionPermission('importAsset')

  const navigate = useNavigation()

  const openBucketsModal = useOpenBucketsModal()
  const openEditBucketModal = useOpenEditBucketModal()
  const openImportHistoryModal = useOpenImportHistoryModal()
  const openExportModal = useOpenExportModal()
  const openExportHistoryModal = useOpenExportHistoryModal()
  const openLinktreesModal = useOpenLinktreesModal()

  const filter = useCleanFilterForRequest()

  const options = [
    ...concatIf(canImport, [
      {
        value: 'import',
        iconLeft: 'RiUploadCloud2Line',
        onClick: () => navigate(`/import/v2/asset`)
      },
      {
        value: 'importHistory',
        iconLeft: 'RiTimeLine',
        onClick: () => openImportHistoryModal('asset')
      },

      { line: true }
    ]),

    ...concatIf(canExport, [
      {
        label: 'export',
        iconLeft: 'RiDownloadCloud2Line',
        onClick: () => openExportModal({ entity: 'asset', filter })
      },
      {
        value: 'exportHistory',
        iconLeft: 'RiTimeLine',
        onClick: () => openExportHistoryModal('asset')
      },
      { line: true }
    ]),

    ...concatIf(canSetup, [
      {
        value: 'fields',
        iconLeft: 'RiListSettingsLine',
        onClick: () => openEditFieldsModal('assets')
      },

      // Qrcode
      { line: true },
      {
        value: 'linktree',
        iconLeft: 'RiNodeTree',
        onClick: () => openLinktreesModal({ entity: 'assets' })
      },

      {
        value: 'qrcode',
        iconLeft: 'BsAspectRatio',
        onClick: () => openEditBucketModal({ type: `assets` })
      },

      {
        value: 'buckets',
        iconLeft: 'BsList',
        onClick: () => openBucketsModal({ type: `assets` })
      }
    ])
  ]

  return (
    <>
      <Separator weight={12} />
      <Grid justify="space-between" gutter={0.4}>
        <Col>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t('listAsset:title')}
          </Title>
        </Col>

        <Col flex={1}></Col>

        {!!options.length && (
          <Col>
            <DropdownLink
              fromRight
              t={key => t(`listAsset:menu.${key}`)}
              options={options}
              actionContent={
                <IconText label={t('moreOptions')} iconName="BsThreeDotsVertical" noWrap size="small" bold />
              }
            />
          </Col>
        )}
      </Grid>

      <Separator weight={2} />
    </>
  )
}

export default PageHeader
